module.exports = __webpack_public_path__ + "img/shareCodeFail.6b2ab337.png";